import megatron, {get} from '@ibibo/megatron';
import {
  REGISTER_API,
  RESENT_OTP_API,
  UPLOAD_PAN_API,
  UPLOAD_KYC_API,
  SET_PASSWORD_URL,
  LOGIN_API,
  TERMS_URL,
  SUBSCRIBERID_UPDATE,
  UPDATE_PASSWORD_URL,
  CHANGE_PASSWORD,
  IS_LOGGED_IN_URL,
  REDIRECT_REQUEST_URL,
  AGENT_HOST,
  SUBMIT_NUMBER,
  SUBMIT_DETAILS,
  SUBMIT_KYCDOC,
  CREATE_PASSWORD,
  SAVE_AGREEMENT,
  GET_TOKEN_DATA,
  GET_AGREEMENT,
  GET_FAQ_TNC,
  GET_DASHBOARD_DATA,
  GET_LOYALTY_TEMPLATE,
  EMAIL_ACTIVATION,
  AGENTPROXY_HOST,
  UPLOAD_LICENSE_DETAILS,
  UPLOAD_TRN_DETAILS,
  SUBMIT_PASSPORT_DETAILS,
  GET_TERMS_AND_CONDTIONS_GCC,
  SAVE_TERMS_AND_CONDITIONS_GCC,
  SUBMIT_MOBILE_NUMBER,
  PAN_VERIFICATION,
  GET_TDS_SLAB,
  MOBILE_VERIFICATION_GCC,
} from '../../constants';
import * as action from './onboarding';
import {IAgentResponse} from '../types';
import {get_cookies} from '../../utils/utils';
import {submitDetailsSuccessResponse} from '../../mock/api-response-mock';
import deviceFingerPrinting from 'MMT-UI/DeviceFingerPrinting';

const header = {
  language: 'eng',
  region: 'IN', //Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta' ? 'IN' : 'AE',
  currency: 'INR', //Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta' ? 'INR' : 'AED',
};

const headerIndia = {
  language: 'eng',
  region: 'IN',
  currency: 'INR',
};

const headerUae = {
  language: 'eng',
  region: 'IN',
  currency: 'INR',
};

export const setAgentData = (token, successCallback, errorCallback) => {
  if (token) {
    return dispatch => {
      return megatron({
        name: 'get agent data',
        url: `${REGISTER_API}`,
        type: 'GET',
        credentials: 'include',
        headers: {token: token, ...header},
      })
        .then((response: IAgentResponse) => {
          if (response && response.success && response.data) {
            dispatch(action.updateInitialData(token, false, response.data));
            successCallback(response.data || '');
          } else {
            errorCallback();
          }
        })
        .catch(error => {
          errorCallback();
        });
    };
  }
};

export const updateSid = (response, successUpdateCallback, override) => {
  return dispatch => {
    if (!override) {
      successUpdateCallback(false);
      return;
    }
    if (window.webpushr) {
      webpushr('fetch_id', function(sid) {
        if (sid) {
          return megatron({
            name: 'update sid',
            url: `${SUBSCRIBERID_UPDATE}?sid=${sid}`,
            type: 'GET',
            credentials: 'include',
          })
            .then((response: IAgentResponse) => {
              successUpdateCallback(true);
            })
            .catch(error => {
              successUpdateCallback(false);
            });
        } else {
          successUpdateCallback(false);
        }
      });
    } else {
      successUpdateCallback(false);
    }
  };
};

export const registerNewUser = (userData, data, successCallback) => {
  return dispatch => {
    dispatch(action.loadingForNext(true));
    return megatron({
      name: 'register user api',
      url: REGISTER_API,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then((response: IAgentResponse) => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success && response.data) {
          dispatch(action.registerNewUserSuccess(userData, response.data));
          successCallback(response.data.token, response.data.status);
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'home',
          };
          dispatch(action.registerNewUserError(userData, errorObj));
        }
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'home',
        };
        dispatch(action.registerNewUserError(userData, errorObj));
      });
  };
};

export const registerNewUserRedirectFlow = (userData, data, successCallback, failureCallBack) => {
  return dispatch => {
    return megatron({
      name: 'register user api',
      url: REGISTER_API,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then((response: IAgentResponse) => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success && response.data) {
          successCallback(response.data.token, response.data.status, response);
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'home',
          };
          if (failureCallBack) {
            failureCallBack(errorObj);
          }
        }
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'home',
        };
        if (failureCallBack) {
          failureCallBack(errorObj);
        }
      });
  };
};

export const resendOTP = (data, type) => {
  return dispatch => {
    megatron({
      name: 'resend otp api',
      url: RESENT_OTP_API,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then((response: IAgentResponse) => {
        if (response && response.success) {
          dispatch(action.resendCount(response.data, type));
        } else {
          dispatch(action.resendCount(response.data, type));
        }
      })
      .catch(e => {
        console.log('ERROR: e = ', e);
      });
  };
};

export const verifyOTP = (userInfo, successCallback) => {
  return dispatch => {
    dispatch(action.loadingForNext(true));
    megatron({
      name: 'register user api',
      url: REGISTER_API,
      type: 'POST',
      credentials: 'include',
      requestData: userInfo,
    })
      .then((response: IAgentResponse) => {
        if (response && response.success) {
          dispatch(action.verifyOTPSuccess(response.data));
          successCallback(response.data.status || '');
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'verify',
          };
          dispatch(action.verifyOTPError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'verify',
        };
        dispatch(action.verifyOTPError(errorObj));
        dispatch(action.loadingForNext(false));
      });
  };
};

export const submitPAN = (data, panNumber, agencyName, successCallBack) => {
  return dispatch => {
    dispatch(action.loadingForKycInfo());
    megatron({
      name: 'pan upload api',
      url: UPLOAD_PAN_API,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then((response: IAgentResponse) => {
        if (response && response.success && response.data) {
          dispatch(action.updatePanInfoSuccess(response.data, panNumber, agencyName));
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'details',
          };
          dispatch(action.updatePanInfoError(errorObj));
          dispatch(action.updateNameIssue(response, panNumber, agencyName));
          successCallBack(response);
        }
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'details',
        };
        dispatch(action.updatePanInfoError(errorObj));
      });
  };
};

export const submitKYC = (data, type) => {
  return dispatch => {
    // dispatch(fetchPanInfo());
    megatron({
      name: 'kyc document upload api',
      url: UPLOAD_KYC_API,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then((response: IAgentResponse) => {
        if (response && response.success) {
          dispatch(action.uploadKYCSuccess(type));
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'details',
          };
          dispatch(action.uploadKYCError(errorObj, type));
        }
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'details',
        };
        dispatch(action.uploadKYCError(errorObj, type));
      });
  };
};

export const submitFacade = (data, type) => {
  return dispatch => {
    // dispatch(fetchPanInfo());
    megatron({
      name: 'kyc document upload api',
      url: UPLOAD_KYC_API,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then((response: IAgentResponse) => {
        if (response && response.success) {
          dispatch(action.uploadFacadeSuccess());
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'details',
          };
          dispatch(action.uploadFacadeError(errorObj));
        }
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'details',
        };
        dispatch(action.uploadFacadeError(errorObj));
      });
  };
};

export const submitData = (formObjData, data, successCallback, errorCallback) => {
  return dispatch => {
    dispatch(action.loadingForNext(true));
    megatron({
      name: 'register user api',
      url: REGISTER_API,
      type: 'POST',
      credentials: 'include',
      requestData: formObjData,
    })
      .then((response: IAgentResponse) => {
        if (response && response.success && response.data) {
          dispatch(action.submitDataSuccess(response.data, data));
          successCallback();
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'details',
          };

          if (!response.success && response.data && response.data.status == 'verify') {
            errorCallback();
          } else {
            dispatch(action.submitDataError(data, errorObj));
          }
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(error => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'details',
        };
        dispatch(action.submitDataError(data, errorObj));
        dispatch(action.loadingForNext(false));
      });
  };
};

export const submitPass = (data, successCallback) => {
  return dispatch => {
    dispatch(action.loadingForNext(true));
    megatron({
      name: 'password update api',
      url: SET_PASSWORD_URL,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then((response: IAgentResponse) => {
        if (response && response.success) {
          successCallback(
            response.redirect_url || '',
            response.data.status || '',
            response.data.campaign || '',
          );
          dispatch(action.setUserCredentials(response.data));
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'update',
          };
          dispatch(action.setUserCredentialsError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'update',
        };
        dispatch(action.setUserCredentialsError(errorObj));
        dispatch(action.loadingForNext(false));
      });
  };
};

export const updatePass = (data, updatePassSuccessCallback, updatePassErrorCallback) => {
  return dispatch => {
    dispatch(action.loadingForNext(true));
    megatron({
      name: 'Update Password API',
      url: CHANGE_PASSWORD,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then((response: IAgentResponse) => {
        if (response && response.success) {
          updatePassSuccessCallback(response);
        } else {
          const errorObj = {...response, data: {account_exists: false}};
          updatePassErrorCallback(errorObj);
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          message: 'Error! Please try after sometime.',
          data: {account_exists: false},
        };
        updatePassErrorCallback(errorObj);
        dispatch(action.loadingForNext(false));
      });
  };
};

export const getPassTokenOrResendToken = (
  mobileOrToken,
  successCallback,
  errorCallback,
  resendOrForgotPwd,
  userEmail = false,
) => {
  return (dispatch, getState) => {
    // dispatch(action.loadingForNext(true));
    const state = getState();
    const country = getState()?.userInfo.country;
    let url = UPDATE_PASSWORD_URL;
    let fd = new FormData();

    const data = state.userInfo?.token
      ? {
          token: state.userInfo.token,
        }
      : userEmail
      ? {
          email: mobileOrToken,
        }
      : {
          mobile: mobileOrToken,
        };
    for (const key in data) {
      fd.append(key, data[key]);
    }

    return megatron({
      name: 'GET USER TOKEN',
      url,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: country ? {...headerUae} : {...headerIndia},
    })
      .then((response: IAgentResponse) => {
        if (response && response.success && response.data) {
          // doing account_exists=false to land the user on update pwd form.(For Login Flow)
          const data = {...response, data: {...response.data, account_exists: false}};
          dispatch(action.updateInitialData(response?.data?.token, false, response.data));
          successCallback(data);
        } else {
          errorCallback(response);
        }
        // dispatch(action.loadingForNext(false));
      })
      .catch(error => {
        // dispatch(action.loadingForNext(false));
        errorCallback({message: 'Error! Please try after sometime.'});
      });
  };
};

export const login = (data, successCallback, errorCallback, sendOTPFn = () => {}) => {
  return (dispatch, getState) => {
    dispatch(action.loadingForNext(true));
    const country = getState()?.userInfo.country;
    megatron({
      name: 'login api',
      url: LOGIN_API,
      type: 'POST',
      credentials: 'include',
      requestData: data,
      headers: country ? {...headerUae} : {...headerIndia},
    })
      .then((response: IAgentResponse) => {
        if (response && response.success) {
          successCallback(response, sendOTPFn);
          deviceFingerPrinting();
        } else {
          // errorCallback(response.message || 'Error! Please try after sometime.');
          errorCallback(response);
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        errorCallback({data: {}, message: 'Error! Please try after sometime.'});
        dispatch(action.loadingForNext(false));
      });
  };
};

export const getTerms = (data, successCallback, errorCallback) => {
  return dispatch => {
    megatron({
      name: 'terms api',
      url: TERMS_URL,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then(response => {
        if (response) {
          successCallback(response);
        } else {
          errorCallback(response || 'Error! Please try after sometime.');
        }
      })
      .catch(() => {
        errorCallback('Error! Please try after sometime.');
      });
  };
};
export const getLoogedInRedirectUrl = async request => {
  let redirectUrl = '';
  let statusCode = 200;
  const sessionId = get_cookies(request)['mp_sessionid'];
  if (sessionId) {
    const name = 'isLogged in api';
    const options = {
      headers: {
        cookie: request.headers.cookie,
        'user-agent': request.headers['user-agent'],
        'Cache-Control': 'no-store, no-cache, must-revalidate',
      },
    };
    const res = await get(IS_LOGGED_IN_URL, {name, options});
    if (res.data?.redirect_url) {
      statusCode = 307; // 307 should be used for temporary redirects
      redirectUrl = res.data?.redirect_url;
    }
  }
  return {
    status: statusCode,
    redirectUrl,
  };
};

export const isUserLoggedIn = async request => {
  const name = 'isLogged in api';
  const options = {
    headers: {
      cookie: request.headers.cookie,
      'user-agent': request.headers['user-agent'],
      'Cache-Control': 'no-store, no-cache, must-revalidate',
    },
  };

  const res = await get(IS_LOGGED_IN_URL, {name, options});

  if (!res?.data?.success) {
    return {
      status: 307,
      redirectUrl: 'https://mypartner.makemytrip.com',
    };
  }

  return {
    status: 200,
  };
};

export const getRedirectUrl = async request => {
  let redirectUrl = '';
  let statusCode = 200;
  const name = 'redirect user api';
  const options = {
    headers: {
      cookie: request.headers.cookie,
    },
  };
  const resurl = encodeURIComponent(AGENTPROXY_HOST + request.originalUrl);
  const response = await get(REDIRECT_REQUEST_URL + `?referrer=${resurl}`, {name, options});
  if (response.data?.redirect_url) {
    statusCode = 307;
    redirectUrl = response.data?.redirect_url;
  }
  return {
    status: statusCode,
    redirectUrl,
  };
};

// new flow api's
export const setAgentDataNew = (token, successCallback, errorCallback) => {
  if (token) {
    return (dispatch, getState) => {
      const country = getState()?.userInfo.country;
      return megatron({
        name: 'get agent data',
        url: `${GET_TOKEN_DATA}`,
        type: 'GET',
        credentials: 'include',
        headers: country ? {...headerUae, token: token} : {...headerIndia, token: token},
      })
        .then((response: IAgentResponse) => {
          if (response && response.success && response.data) {
            dispatch(action.updateInitialData(token, false, response.data));
            successCallback(response.data || '');
          } else {
            errorCallback();
          }
        })
        .catch(error => {
          errorCallback();
        });
    };
  }
};

export const getMobileOtp = (userData, data, successCallback, userCountrySelected = false) => {
  return (dispatch, getState) => {
    dispatch(action.loadingForLogin(true));
    const country = getState()?.userInfo.country;
    return megatron({
      name: 'get otp api',
      url: SUBMIT_NUMBER,
      type: 'POST',
      credentials: 'include',
      requestData: data,
      headers: country ? {...headerUae} : {...headerIndia},
    })
      .then((response: IAgentResponse) => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success && response.data) {
          dispatch(action.sendMobileOtp(userData, response.data));
          successCallback(response.data.token, response.data.status, response.data.nof);
          dispatch(action.loadingForLogin(false));
          dispatch(action.disabledContinueBtn(true));
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'home',
          };
          dispatch(action.sendMobileOtpError(userData, errorObj));
        }
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'home',
        };
        dispatch(action.sendMobileOtpError(userData, errorObj));
      });
  };
};

export const submitOtp = (data, successCallback) => {
  return (dispatch, getState) => {
    dispatch(action.loadingForNext(true));
    const country = getState()?.userInfo.country;
    megatron({
      name: 'verify otp enter api',
      url: SUBMIT_NUMBER,
      type: 'POST',
      credentials: 'include',
      requestData: data,
      headers: country ? {...headerUae} : {...headerIndia},
    })
      .then((response: IAgentResponse) => {
        if (response && response.success && response.data) {
          dispatch(action.verifyMobileOtpSuccess(response.data));
          successCallback(response.data.screen);
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'verify',
          };
          dispatch(action.verifyMobileOtpError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'verify',
        };
        dispatch(action.verifyOTPError(errorObj));
        dispatch(action.loadingForNext(false));
      });
  };
};

export const submitDetails = (formObjData, data, successCallback, errorCallback) => {
  return (dispatch, getState) => {
    dispatch(action.loadingForNext(true));
    const country = getState()?.userInfo.country;
    megatron({
      name: 'register user api',
      url: SUBMIT_DETAILS,
      type: 'POST',
      credentials: 'include',
      requestData: formObjData,
      headers: country ? {...headerUae} : {...headerIndia},
    })
      .then((response: IAgentResponse) => {
        if (response && response.success && response.data) {
          dispatch(action.submitDetailsSuccess(response.data, data));
          successCallback(response.data);
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'details',
          };
          dispatch(action.submitDetailsError(data, errorObj));
          errorCallback(response);
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(error => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'details',
        };
        errorCallback(error);
        dispatch(action.submitDetailsError(data, errorObj));
        dispatch(action.loadingForNext(false));
      });
  };
};

export const submitKycDoc = (formObjData, data, successCallback, errorCallack) => {
  return (dispatch, getState) => {
    dispatch(action.loadingForNext(true));
    const country = getState()?.userInfo.country;
    megatron({
      name: 'submit kyc doc',
      url: SUBMIT_KYCDOC,
      type: 'POST',
      credentials: 'include',
      requestData: formObjData,
      headers: country ? {...headerUae} : {...headerIndia},
    })
      .then((response: IAgentResponse) => {
        if (response && response.success && response.data) {
          dispatch(action.nextScreenSuccess(response.data));
          successCallback(response.data.screen);
        } else {
          const errorObj = {
            msg: response.message,
            screen: 'kycdoc',
          };
        }
        if (!response.success && response.data && response.data.status == 'verify') {
          errorCallack();
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(error => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'details',
        };
        dispatch(action.loadingForNext(false));
      });
  };
};

export const submitUserPass = (data, token, successCallback) => {
  return (dispatch, getState) => {
    dispatch(action.loadingForNext(true));
    const country = getState()?.userInfo.country;
    megatron({
      name: 'password update api',
      url: CREATE_PASSWORD,
      type: 'POST',
      credentials: 'include',
      requestData: data,
      headers: country ? {...headerUae} : {...headerIndia},
    })
      .then((response: IAgentResponse) => {
        if (response && response.success) {
          successCallback(
            response.redirect_url || '',
            response.data.status || '',
            response.data.campaign || '',
          );
          dispatch(action.setUserCredentials(response.data));
          dispatch(action.nextScreenSuccess(response.data));
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'setpassword',
          };
          dispatch(action.setUserCredentialsError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'setpassword',
        };
        dispatch(action.setUserCredentialsError(errorObj));
        dispatch(action.loadingForNext(false));
      });
  };
};

export const submitTnCAgree = (data, successCallback, errorCallack) => {
  return dispatch => {
    dispatch(action.loadingForNext(true));
    megatron({
      name: 'tnc agree update api',
      url: SAVE_AGREEMENT,
      type: 'POST',
      credentials: 'include',
      requestData: data,
    })
      .then((response: IAgentResponse) => {
        if (response && response.success) {
          successCallback(response.data.screen);
          dispatch(action.nextScreenSuccess(response.data));
        } else {
          const errorObj = {
            msg: response.message || 'Error! Please try after sometime.',
            screen: 'update',
          };
          errorCallack(errorObj.screen);
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(err => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'update',
        };
        dispatch(action.loadingForNext(false));
      });
  };
};

export const termsPageRequest = (token, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      //const url = `${getLoyaltyAgnApi}`;
      const obj = {doc_type: 'taxation_agreement', user_type: 'new', token: token};
      let fd = new FormData();
      for (const key in obj) {
        fd.append(key, obj[key]);
      }
      megatron({
        name: 'tnc agree update api',
        url: GET_AGREEMENT,
        type: 'POST',
        credentials: 'include',
        requestData: fd,
      }).then(response => {
        if (response) {
          successCallback(response);
        } else {
          errorCallback(response || 'Error! Please try after sometime.');
        }
      });
    } catch {}
  };
};

export const agreementAcceptanceRequest = (data, successCallback, errorCallback) => {
  return async dispatch => {
    dispatch(action.loadingForNext(true));
    try {
      const url = GET_AGREEMENT;
      const obj = {
        agn_accept: 'true',
        user_type: 'new',
        token: data.token,
        agreed_time: data.userConsent,
        doc_type: 'taxation_agreement',
      };
      let fd = new FormData();
      for (const key in obj) {
        fd.append(key, obj[key]);
      }
      megatron({
        name: 'tnc agree update api',
        url: GET_AGREEMENT,
        type: 'POST',
        credentials: 'include',
        requestData: fd,
      })
        .then(response => {
          dispatch(action.loadingForNext(false));
          successCallback(response?.data?.screen);
        })
        .catch(err => {
          dispatch(action.loadingForNext(false));
        });
    } catch {}
  };
};

export const getLoyaltyFaqAndTncData = (successCallBack, errorCallback) => {
  return async dispatch => {
    return megatron({
      name: 'get loyalty faq and tnc data',
      url: `${GET_FAQ_TNC}`,
      type: 'GET',
      credentials: 'include',
      headers: {},
    })
      .then(response => {
        successCallBack(response?.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  };
};

export const getLoyaltyDashboardData = (
  month,
  get_graph_data = true,
  successCallback,
  errorCallback,
) => {
  return dispatch => {
    return megatron({
      name: 'get user loyalty dashboard data',
      url: `${GET_DASHBOARD_DATA}/?month=${month}&get_graph_data=${get_graph_data}`,
      type: 'GET',
      credentials: 'include',
    })
      .then(response => {
        successCallback(response);
      })
      .catch(error => {
        errorCallback(error);
      });
  };
};

export const getLoyaltyPageTemplate = (successCallback, errorCallback) => {
  return dispatch => {
    return megatron({
      name: 'get user loyalty dashboard data',
      url: `${GET_LOYALTY_TEMPLATE}`,
      type: 'GET',
      credentials: 'include',
    })
      .then(response => {
        successCallback(response);
      })
      .catch(error => {
        errorCallback(error);
      });
  };
};

//1st => get request {}
//2nd => user can edit or not and user can bypass or not
// if edit send the

export const getEmailOtpVerificationData = (successCallback, errorCallback) => {
  return dispatch => {
    dispatch(action.loadingForLogin(true));
    return megatron({
      name: 'get otp api',
      url: EMAIL_ACTIVATION,
      type: 'GET',
      credentials: 'include',
    })
      .then(response => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success && response.data) {
          successCallback(response.data);
        } else {
          errorCallback(response.data);
        }
      })
      .catch(err => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'home',
        };
        errorCallback(err);
        dispatch(action.sendMobileOtpError(errorObj, errorObj));
      });
  };
};

export const sendEmailOtpVerification = (email, successCallback, errorCallback) => {
  return dispatch => {
    dispatch(action.loadingForLogin(true));
    const obj = {
      email: email,
    };
    let fd = new FormData();
    for (const key in obj) {
      fd.append(key, obj[key]);
    }
    return megatron({
      name: 'get otp api',
      url: EMAIL_ACTIVATION,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: {...headerIndia},
    })
      .then(response => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success && response.data) {
          successCallback(response.data);
        } else {
          errorCallback(response.data);
        }
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'home',
        };
        dispatch(action.sendMobileOtpError(errorObj, errorObj));
      });
  };
};

export const sendEmailOtpDataForVerification = (otp, email, successCallback, errorCallback) => {
  return dispatch => {
    dispatch(action.loadingForLogin(true));
    const obj = {
      otp: otp,
      email: email,
    };
    let fd = new FormData();
    for (const key in obj) {
      fd.append(key, obj[key]);
    }
    return megatron({
      name: 'get otp api',
      url: EMAIL_ACTIVATION,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
    })
      .then(response => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success && response.data.otp_verified) {
          successCallback(response.data);
        } else {
          errorCallback(response.message);
        }
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'home',
        };
        dispatch(action.sendMobileOtpError(errorObj, errorObj));
      });
  };
};

//GCC Onboarding api for uploading licnese doc and license number
export const submitLicenseDetails = (data, token, successCallback, errorCallback) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }

  return (dispatch, getState) => {
    const country = getState()?.userInfo?.country;
    megatron({
      name: 'submit license details',
      url: UPLOAD_LICENSE_DETAILS,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: country ? {...headerUae, token: token} : {...headerIndia, token: token},
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
          dispatch(action.verifyMobileOtpError({}));
        } else {
          const errorObj = {
            msg: response?.message || 'Error! Please try after sometime.',
            screen: 'verify',
            is_editable: response?.is_editable,
          };
          errorCallback(errorObj);
          dispatch(action.verifyMobileOtpError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'verify',
        };
      });
  };
};

//GCC Onboarding api for uploading trn number
export const submitTrnDetails = (data, token, successCallback, errorCallback) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const country = getState()?.userInfo?.country;
    megatron({
      name: 'submit license details',
      url: UPLOAD_TRN_DETAILS,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: country ? {...headerUae, token: token} : {...headerIndia, token: token},
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
          dispatch(action.verifyMobileOtpError({}));
        } else {
          const errorObj = {
            msg: response?.message || 'Error! Please try after sometime.',
            screen: 'verify',
          };
          dispatch(action.verifyMobileOtpError(errorObj));
          errorCallback();
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'verify',
        };
        dispatch(action.verifyMobileOtpError(errorObj));
        errorCallback();
      });
  };
};

//GCC Onboarding api for uploading passport details
export const submitPassportDetails = (data, token, successCallback, errorCallback) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const country = getState()?.userInfo?.country;
    megatron({
      name: 'submit license details',
      url: SUBMIT_PASSPORT_DETAILS,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: country ? {...headerUae, token: token} : {...headerIndia, token: token},
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
          dispatch(action.verifyMobileOtpError({}));
        } else {
          const errorObj = {
            msg: response?.message || 'Error! Please try after sometime.',
            screen: 'verify',
          };
          errorCallback();
          dispatch(action.uploadPassportInfoError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'verify',
        };
        errorCallback();
        dispatch(action.verifyMobileOtpError(errorObj));
      });
  };
};

//GCC Onboarding api for getting terms and conditions data
export const getTermsAndConditionsForGcc = (data, token, successCallback, errorCallback) => {
  let fd = new FormData();

  for (const key in data) {
    fd.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const country = getState()?.userInfo?.country;
    megatron({
      name: 'submit license details',
      url: GET_TERMS_AND_CONDTIONS_GCC,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: country ? {...headerUae, token: token} : {...headerIndia, token: token},
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
          dispatch(action.verifyMobileOtpError({}));
        } else {
          errorCallback(response);
          const errorObj = {
            msg: response?.message || 'Error! Please try after sometime.',
            screen: 'verify',
          };
          dispatch(action.verifyMobileOtpError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'verify',
        };
      });
  };
};

//GCC Onboarding api for saving terms and conditions data
export const saveTermsAndConditionsForGcc = (data, token, successCallback, errorCallback) => {
  let fd = new FormData();

  for (const key in data) {
    fd.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const country = getState()?.userInfo?.country;
    megatron({
      name: 'submit license details',
      url: SAVE_TERMS_AND_CONDITIONS_GCC,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: country ? {...headerUae, token: token} : {...headerIndia, token: token},
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
          dispatch(action.verifyOTPError({}));
        } else {
          const errorObj = {
            msg: response?.message || 'Error! Please try after sometime.',
            screen: 'verify',
          };
          errorCallback(response);
          dispatch(action.verifyMobileOtpError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'verify',
        };
      });
  };
};

export const getPanVerificationData = (successCallback, errorCallback, retryValue = 0) => {
  return dispatch => {
    dispatch(action.loadingForLogin(true));
    const fd = new FormData();
    if (retryValue) {
      fd.append('retry', retryValue);
    }
    fd.append('verificationType', 'GSTN_PAN_Verification');
    fd.append('action', 'generateOtp');
    const headers = {
      language: 'eng',
      region: 'IN',
      currency: 'INR',
    };
    return megatron({
      name: 'get otp api for pan',
      url: PAN_VERIFICATION,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: {...headers},
    })
      .then(response => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success) {
          successCallback(response);
        } else {
          errorCallback(response.data);
        }
      })
      .catch(err => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'home',
        };
        errorCallback(err);
        dispatch(action.sendMobileOtpError(userData, errorObj));
      });
  };
};

export const submitPanVerificationOtpData = (otp, action, successCallback, errorCallback) => {
  return dispatch => {
    const fd = new FormData();
    fd.append('verificationType', 'GSTN_PAN_Verification');
    fd.append('action', action);
    fd.append('otp', otp);
    const headers = {
      language: 'eng',
      region: 'IN',
      currency: 'INR',
    };
    return megatron({
      name: 'get otp api for pan',
      url: PAN_VERIFICATION,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: {...headers},
    })
      .then(response => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success) {
          successCallback(response);
        } else {
          errorCallback(response?.error);
        }
      })
      .catch(err => {
        errorCallback('Error! Please try after sometime.');
      });
  };
};

export const skipPanVerificationData = (reason, action, successCallback, errorCallback) => {
  return dispatch => {
    const fd = new FormData();
    fd.append('verificationType', 'GSTN_PAN_Verification');
    fd.append('action', action);
    fd.append('reason', reason);
    const headers = {
      language: 'eng',
      region: 'IN',
      currency: 'INR',
    };
    return megatron({
      name: 'get otp api for pan',
      url: PAN_VERIFICATION,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: {...headers},
    })
      .then(response => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success) {
          successCallback(response);
        } else {
          errorCallback(response.data);
        }
      })
      .catch(err => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'home',
        };
        errorCallback(err);
        dispatch(action.sendMobileOtpError(userData, errorObj));
      });
  };
};

export const getTdsSlabData = (successCallback, errorCallback) => {
  return dispatch => {
    const headers = {
      language: 'eng',
      region: 'IN',
      currency: 'INR',
    };
    return megatron({
      name: 'get tds slab',
      url: GET_TDS_SLAB,
      type: 'GET',
      credentials: 'include',
      headers: {...headers},
    })
      .then(response => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success) {
          successCallback(response);
        } else {
          errorCallback(response);
        }
      })
      .catch(err => {
        errorCallback(err);
      });
  };
};
//GCC MOBILE VERIFICATION
export const getGccMobileVerificationData = (successCallback, errorCallback) => {
  return (dispatch, getState) => {
    const country = getState()?.userInfo?.country;
    return megatron({
      name: 'get verification api',
      url: MOBILE_VERIFICATION_GCC,
      type: 'GET',
      credentials: 'include',
      headers: {...headerUae},
    })
      .then(response => {
        // response = registerNewUserErrorResponse; // to test error case
        if (response && response.success && response.data) {
          successCallback(response.data);
        } else {
          errorCallback(response.data);
        }
      })
      .catch(err => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'home',
        };
        errorCallback(err);
        dispatch(action.sendMobileOtpError(userData, errorObj));
      });
  };
};

export const submitGccMobileOtpVerificationNumber = (data, successCallback, errorCallback) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }
  return (dispatch, getState) => {
    megatron({
      name: 'submit mobile details',
      url: MOBILE_VERIFICATION_GCC,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
      headers: {...headerUae, token: data.token},
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
        } else {
          const errorObj = {
            msg: response?.message || 'Error! Please try after sometime.',
            screen: 'verify',
          };
          errorCallback(response);
          //dispatch(action.verifyMobileOtpError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          message: 'Error! Please try after sometime.',
        };
        errorCallback(errorObj);
      });
  };
};

export const submitGccMobileOtp = (data, successCallback, errorCallback) => {
  return (dispatch, getState) => {
    megatron({
      name: 'submit mobile details',
      url: MOBILE_VERIFICATION_GCC,
      type: 'POST',
      credentials: 'include',
      requestData: data,
      headers: {...headerUae, token: data.token},
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
        } else {
          const errorObj = {
            msg: response?.message || 'Error! Please try after sometime.',
            screen: 'verify',
          };
          errorCallback(response);
          dispatch(action.verifyMobileOtpError(errorObj));
        }
        dispatch(action.loadingForNext(false));
      })
      .catch(() => {
        const errorObj = {
          message: 'Error! Please try after sometime.',
        };
      });
  };
};

export const makeGetRequest = (url, successCallback, errorCallback) => {
  return (dispatch, getState) => {
    return megatron({
      name: 'get agent data',
      url: `${url}`,
      type: 'GET',
      credentials: 'include',
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
        } else {
          errorCallback(response);
        }
      })
      .catch(error => {
        errorCallback({message: 'Something went wrong'});
      });
  };
};

export const makePostRequest = (data, url, successCallback, errorCallback) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }

  return (dispatch, getState) => {
    megatron({
      name: 'data post request',
      url: url,
      type: 'POST',
      credentials: 'include',
      requestData: fd,
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
        } else {
          const errorObj = {
            msg: response?.message || 'Error! Please try after sometime.',
            screen: 'verify',
          };
          errorCallback(response);
          //dispatch(action.verifyMobileOtpError(errorObj));
        }
        //dispatch(action.loadingForNext(false));
      })
      .catch(err => {
        const errorObj = {
          message: 'Error! Please try after sometime.',
        };
        errorCallback(errorObj);
      });
  };
};
